/* 
Props Definition-
getActiveList - List to show in dropdown options
activeFilters - active filters if any, to prefill in field by extracting relevant information
activeElement - activeItem if any, in case of modalState="Edit" to prefill in field by extracting relevant information
getActiveItemById - redux function to get active item by id, in case of edit state (in order to extract name to pair it with id)
nextPage - redux state, in order to show pagination or not (can be used in both CastForEducationSharp, if there is no pagination, nextPage will be -1, so it will not show)
resKey - response key that contains the required list
modalState - active modal state of modal or form
keyName - name of key having id to map the options
labelKey - name of key contains "name" or any parameter to pair it with id, to map them as object like {id : "", name : ""} in options, if want to map on one key only, like name only, then pass labelKey same as keyName
getDataLabelKey - name of key to get data from api using getDataById (like country.country_name)
keyTypeToSet - key to set from options, suppose in options object, id is coming, so pass "id", then it will set options[0].id to keyName
disabled - If disable the Component
stateDependent- If onchange has to change to state of component, not nested one
label - Label or name of the dropdown component
appliedFilters - if any filters to apply while fetching list
handleChange - function to set the value of field having name as keyName
remoteSearchApplicable - to give the functionality of remote search, set to true, otherwise false
remoteSearchKey - if remoteSearchApplicable is set to true, then pass remoteSearchKey on which you to apply the search, (basically the key you want to send in the api to fetch results prefixed with the value of dropdown)
priorityFlag - mandatory field to send, used for ordering if useEffects
*/

import React, { useState, useEffect } from "react";
import { getPath, debounce, throttle } from "../../../utils";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";
import ArrowDropDown from "@material-ui/icons/ArrowDropDown";
import TextField from "@material-ui/core/TextField";
import Autocomplete from "@material-ui/lab/Autocomplete";
import ChevronDown from "sushiweb/Icons/all/ChevronDown";
import CrossCircle from "sushiweb/Icons/all/CrossCircle";
const scrollOffset = 10;
const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: "#3f50b5",
  },
}));
const InfiniteScrollDropdown = (props) => {
  const classes = useStyles();
  const {
    getActiveList,
    nextPage,
    resKey,
    modalState,
    activeFilters,
    getActiveItemById,
    activeElement,
    keyName,
    keyTypeToSet,
    labelKey,
    handleChange,
    label,
    remoteSearchApplicable,
    remoteSearchKey,
    getDataLabelKey,
    id,
    stateDependent,
    appliedFilters,
    priorityFlag,
    appliedFilterValue,
    additionalParams,
    labels = [],
    makeNoInitialCall,
    setPriorityFlag,
    value, //initialValue to show
    extraParams = [], //extraparams to send in handlechange,
    shouldClear, //clear the dropdown if the state is true
    notShowCross, //boolean field if to show cross or not to clear the dropdown
    allowDuplicateOptions,
    defaultVal, //set initial value if available
    freeSolo,
    setPartialString,
  } = props;

  const defaultActiveItemValue = defaultVal
    ? defaultVal
    : props.multiple
    ? []
    : {};
  const [currList, setCurrList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [showDefaultVal, setShowDefaultVal] = useState(true);
  const [activeItem, setActiveItem] = useState(defaultActiveItemValue);
  const removeDuplicates = (arr) => {
    const newArr = [];
    const set = new Set();
    arr.forEach((obj) => {
      if (set.has(obj.id) === false) {
        set.add(obj.id);
        newArr.push(obj);
      }
    });
    return newArr;
  };
  const updateState = throttle(() => {
    if (nextPage === -1 || props.disabled) {
      return;
    }
    setIsLoading(true);
    const pageRequest = { page: currentPage + 1 };
    setTimeout(() => {
      getActiveList(appliedFilters, pageRequest, additionalParams)
        .then((res) => {
          let newList = getPath(res, resKey, []);
          newList = allowDuplicateOptions
            ? [...currList, ...newList]
            : removeDuplicates([...currList, ...newList]);
          setCurrList(newList);
          setCurrentPage(pageRequest.page);
          setIsLoading(false);
        })
        .catch((err) => {
          console.log("Error on Infinite", err);
          setIsLoading(false);
        });
    }, 500);
  }, 500);

  const getLabelFromLabelsProp = (option) => {
    //for feature toggle locality usecase
    let label1 = option[labels[1]] || option["entityValue"];
    return `${option[labels[0]]} (${labels[1]} : ${label1})`;
  };

  useEffect(() => {
    if (priorityFlag) {
      if (
        activeFilters &&
        modalState === "Filter" &&
        getPath(Object.keys(activeFilters), "length", -1) > 0
      ) {
        const activeId = activeFilters[keyName];
        if (activeId) {
          let currObj = props.multiple ? [] : {};
          if (keyName === labelKey) {
            currObj[keyName] = activeId;
            setActiveItem(currObj);
          } else {
            getActiveItemById(activeId).then((res) => {
              if (props.multiple) {
                for (let i = 0; i < activeId.length; i++) {
                  let temp = {};
                  temp[keyTypeToSet] = activeId[i];
                  temp[labelKey] = res[i][labelKey];
                  currObj = [...currObj, temp];
                }
              } else {
                const activeName = getDataLabelKey
                  ? getPath(res, getDataLabelKey, null)
                  : labels.length > 0
                  ? getLabelFromLabelsProp(res)
                  : res[labelKey];
                currObj[keyTypeToSet] = activeId;
                currObj[labelKey] = activeName;
              }
              setActiveItem(currObj);
            });
          }
        } else {
          setActiveItem({});
        }
      }
      if (
        activeElement &&
        modalState === "Edit" &&
        getPath(Object.keys(activeElement), "length", -1) > 0
      ) {
        const activeId = (activeElement.lhs == "service_id") ? (getActiveServiceId(activeElement)) : activeElement[keyName];
        if (activeId) {
          let currObj = props.multiple ? [] : {};
          if (keyName === labelKey) {
            currObj[keyName] = activeId;
            setActiveItem(currObj);
          } else {
            if (getActiveItemById) {
              getActiveItemById(activeId).then((res) => {
                if (props.multiple) {
                  for (let i = 0; i < activeId.length; i++) {
                    let temp = {};
                    temp[keyTypeToSet] = activeId[i];
                    temp[labelKey] = res[i][labelKey];
                    currObj = [...currObj, temp];
                  }
                } else {
                  const activeName = getDataLabelKey
                    ? getPath(res, getDataLabelKey, null)
                    : labels.length > 0
                    ? getLabelFromLabelsProp(res)
                    : res[labelKey];
                  currObj[keyName] = activeId;
                  currObj[labelKey] = activeName;
                }
                setActiveItem(currObj);
              });
            }
          }
        } else {
          setActiveItem({});
        }
      }
    }
  }, [JSON.stringify(activeElement), priorityFlag]);

  useEffect(() => {
    if (priorityFlag) {
      const pageRequest = {
        page: 1,
      };
      setCurrentPage(1);
      setActiveItem(defaultActiveItemValue);
      !makeNoInitialCall &&
        getActiveList(appliedFilters, pageRequest, additionalParams).then(
          (res) => {
            const tempList = [...getPath(res, resKey, [])];
            setCurrList(tempList);
            setPriorityFlag && setPriorityFlag(false);
          }
        );
    }
  }, [priorityFlag]);

  const getActiveServiceId = (activeElement) => {
    let activeId = [];
    activeElement.rhs.forEach((element) => {
      if(element){
        if(typeof element === 'number') activeId.push(element);
      }
    });
    return activeId;
  }

  useEffect(() => {
    //specific to feature toggle
    if (
      id === "activeLocalityDropdown" &&
      Object.keys(appliedFilters).length > 0
    ) {
      const pageRequest = {
        page: currentPage,
      };
      setActiveItem({});
      getActiveList(appliedFilters, pageRequest, additionalParams).then(
        (res) => {
          let tempList = [...getPath(res, resKey, [])];
          setCurrList(tempList);
        }
      );
    } else if (
      id === "activeLocalityDropdown" &&
      Object.keys(appliedFilters).length === 0
    ) {
      setCurrList([]);
      setActiveItem({});
    }
  }, [appliedFilterValue]);

  useEffect(() => {
    if (shouldClear) {
      setActiveItem({});
    }
  }, [shouldClear]);

  useEffect(() => {
    if (defaultVal && showDefaultVal) {
      setActiveItem(defaultVal);
    }
  }, [defaultVal]);

  const handleInputChange = debounce((val) => {
    const filters = {
      [remoteSearchKey]: val,
      ...appliedFilters,
    };
    const pageRequest = {
      page: 1,
    };
    getActiveList(filters, pageRequest, additionalParams).then((res) => {
      const newList = [...getPath(res, resKey, [])];
      setCurrList(newList);
      setCurrentPage(1);
      setShowDefaultVal(false);
    });
  }, 500);
  return (
    <Autocomplete
      style={{ width: "fit-content" }}
      disabled={props.disabled}
      multiple={props.multiple}
      id={id}
      data-testid="autocomplete-dropdown"
      getOptionSelected={(opt, val) => {
        if (freeSolo) {
          return false;
        }
        return opt.id === val.id;
      }}
      options={currList}
      getOptionLabel={(option) => {
        if (freeSolo) {
          return option;
        }
        if (props.getOptionLabelOverride && typeof props.getOptionLabelOverride === 'function') {
          return props.getOptionLabelOverride(option);
        }
        return (
          (labels.length > 0 && Object.keys(option).length > 0
            ? getLabelFromLabelsProp(option)
            : option[labelKey]) || ""
        );
      }}
      freeSolo={freeSolo}
      filter={(searchText, key) => true}
      popupIcon={isLoading ? <CircularProgress size={25} /> : <ArrowDropDown />}
      renderInput={(params) => (
        <TextField {...params} label={label} variant="outlined" />
      )}
      ListboxProps={{
        onScroll: (event) => {
          const listboxNode = event.currentTarget;
          if (
            listboxNode.scrollTop + listboxNode.clientHeight + scrollOffset >=
            listboxNode.scrollHeight
          ) {
            updateState();
          }
        },
      }}
      onInputChange={(evt, val) => {
        remoteSearchApplicable && handleInputChange(val);
        if (setPartialString) {
          setPartialString(val);
        }
      }}
      onChange={(evt, val) => {
        if (val) {
          setActiveItem(val);
          if (props.multiple) {
            handleChange(
              keyName,
              val.map((cur) => cur[keyTypeToSet]),
              [...extraParams],
              val
            );
          } else {
            stateDependent
              ? handleChange(val[keyTypeToSet])
              : handleChange(keyName, val[keyTypeToSet], [...extraParams], val);
          }
        } else {
          setActiveItem(defaultActiveItemValue);
          stateDependent
            ? handleChange("")
            : handleChange(keyName, "", [...extraParams], {});
        }
      }}
      // popupIcon={<ChevronDown />}
      disableClearable={notShowCross === undefined ? false : notShowCross}
      closeIcon={<CrossCircle className="cross" />}
      value={value || activeItem}
    />
  );
};

InfiniteScrollDropdown.defaultProps = {
  multiple: false,
};

export default InfiniteScrollDropdown;
